import type { RfqViewState } from "./rfq-view-types";
import type { Rfq } from "../../domain/rfq-types";
import { invitationSummary } from "./rfq-presentation";

type Props = Pick<RfqViewState,
  "rfq" |
  "invitations" |
  "invitationLoading" |
  "invitationsLoaded" |
  "invitationError" |
  "loadInvitations" |
  "invitationDrawerSupplierId" |
  "setInvitationDrawerSupplierId" |
  "clearInvitationFeedback"
> & { rfq: Rfq };
export function RfqInvitations({
  rfq,
  invitations,
  invitationLoading,
  invitationsLoaded,
  invitationError,
  loadInvitations,
  invitationDrawerSupplierId,
  setInvitationDrawerSupplierId,
  clearInvitationFeedback,
}: Props) {
  return (
    <section
              className="rfq-invitations"
              aria-label="Tedarikçi davetleri"
            >
              <div className="rfq-invitations-heading">
                <div>
                  <span className="section-kicker">Güvenli erişim</span>
                  <h3>Tedarikçi Davetleri</h3>
                  <p>
                    Her tedarikçinin teslimat durumunu tek yerden izleyin.
                  </p>
                </div>
                <span className="rfq-invitation-count">
                  {invitationsLoaded && rfq.selections ? `${invitations.length}/${rfq.selections.length} oluşturuldu` : "Davet sayısı doğrulanmadı"}
                </span>
              </div>
              {invitationLoading ? (
                <p role="status">Davet durumları yükleniyor…</p>
              ) : invitationError && !invitationDrawerSupplierId ? (
                <div className="error-state" role="alert">
                  <span>{invitationError}</span>
                  <button
                    className="secondary-button"
                    onClick={() => loadInvitations(rfq.id)}
                  >
                    Yeniden dene
                  </button>
                </div>
              ) : !rfq.selections ? (
                <p>Tedarikçi seçimi doğrulanmadı. Teklif talebini yenileyin.</p>
              ) : !(rfq.selections ?? []).length ? (
                <div className="table-state">
                  <strong>Davet edilecek tedarikçi yok</strong>
                  <span>Önce uygun bir tedarikçi seçimi yayımlayın.</span>
                </div>
              ) : (
                (rfq.selections ?? []).map((selection) => {
                  const supplierId =
                      selection.supplier_id ?? selection.supplierId ?? "",
                    existing = invitations.find(
                      (item) =>
                        (item.supplierId ?? item.supplier_id) === supplierId,
                    );
                  return (
                    <article key={supplierId} className="rfq-invitation-row">
                      <div className="rfq-invitation-identity">
                        <strong>
                          {selection.supplier_name ?? selection.supplierName}
                        </strong>
                        <span>
                          {existing
                            ? invitationSummary(existing)
                            : invitationsLoaded ? "Henüz davet oluşturulmadı" : "Davet kaydı doğrulanmadı"}
                        </span>
                        {existing ? (
                          <small>
                            {existing.contactName} · {existing.recipient}
                          </small>
                        ) : (
                          <small>Gönderim kişisi sunucuda doğrulanır.</small>
                        )}
                      </div>
                      <button
                        data-invitation-supplier={supplierId}
                        disabled={!invitationsLoaded}
                        className={
                          existing ? "secondary-button" : "primary-button"
                        }
                        onClick={() => {
                          setInvitationDrawerSupplierId(supplierId);
                          clearInvitationFeedback();
                        }}
                      >
                        {existing ? "Daveti yönet" : "Davet oluştur"}
                      </button>
                    </article>
                  );
                })
              )}
            </section>
  );
}
